/* Routes under /clinic_id/... */
export enum ClinicDashBoardRoute {
  Invite = "invite",
  Patients = "patients",
  Advanced = "advanced-settings",
  Users = "users",
  Translation = "translation",
  ImportPatients = "import",
  ThemeColors = "theme-colors",
  Settings = "settings",
  PatientCard = "patientCard",
  EhrIntegPatientCard = "ehrPatientCard",
  InvitePrint = "invitePrint",
}
/* Routes under /clinic_management/... */
export enum ClinicRoute {
  New = "new",
  Duplicate = "duplicate",
  Start = "start",
  Welcome = "welcome",
  WelcomeToClinic = "welcomeToClinic",
  Login = "login",
  Signup = "signup",
  Verify = "verify",
  ForgotPassword = "forgotPassword",
  Demo = "demo",
}

export type AllClinicRoutes = ClinicRoute | ClinicDashBoardRoute;
